import React from 'react';
import { Modal, Spin, Flex, theme } from 'antd';

import './Modal.less';

const { useToken } = theme;

const Confirmation = ({ open, loading = false, cancelText = 'No', okText = 'Yes', onCancel, onOk, width = 451, children, ...rest }) => {
	const { token } = useToken();

	return (
		<Modal
			className="custom-modal"
			{...rest}
			centered
			open={open}
			width={width}
			footer={(
				<Flex
					style={{
						height: '100%'
					}}
				>
					<Flex
						justify="center"
						align="center"
						onClick={onCancel}
						style={{
							width: '50%',
							borderTopWidth: 1,
							borderRightWidth: 1,
							borderLeftWidth: 0,
							borderBottom: 0,
							borderStyle: 'solid',
							borderColor: '#0000001A',
							cursor: 'pointer',
							...(loading && { pointerEvents: 'none' })
						}}
					>
						{cancelText}
					</Flex>
					<Flex
						justify="center"
						align="center"
						onClick={onOk}
						style={{
							width: '50%',
							borderTopWidth: 1,
							borderLeftWidth: 1,
							borderRightWidth: 0,
							borderBottom: 0,
							borderStyle: 'solid',
							borderColor: '#0000001A',
							cursor: 'pointer',
							color: token.colorLink,
							...(loading && { pointerEvents: 'none' })
						}}
					>
						{loading ? <Spin /> : okText}
					</Flex>
				</Flex>
			)}
			closable={false}
			title="Confirmation"
			styles={{
				header: {
					padding: '24px 26px'
				},
				body: {
					padding: '34px 34px',
					textAlign: 'center'
				},
				footer: {
					height: 66,
					textAlign: 'center'
				}
			}}
		>
			<div className="modal-content">
				{children}
			</div>
		</Modal>
	);
};

export default Confirmation;